<template>
	<div class="projectDetail-container">
		<div v-loading="loading" class="project-detail-content">
			<div class="timeline">
				<template v-if="detailInfo.length > 0">
					<div v-for="item in detailInfo" :key="item.id" class="timeline-item">
						<div class="timeline-header">
							<div class="timeline-title">
								<i class="timeline-dot"></i>
								{{ item.companyName }}
							</div>
							<div class="timeline-timestamp">{{ item.registerTime }}</div>
						</div>
						<div class="timeline-content">
							<div class="timeline-info">
								<div class="timeline-info-item">
									<span class="timeline-info-item__label">注册专业：</span>
									<span class="timeline-info-item__value">{{ item.registerProject }}</span>
								</div>
								<div class="timeline-info-item">
									<span class="timeline-info-item__label"></span>
									<span class="timeline-info-item__value">{{ item.companyName }}</span>
								</div>
							</div>
						</div>
					</div>
				</template>
				<!-- 数据为空 -->
				<empty-content v-else></empty-content>
			</div>
			<!-- 未开通会员提示 -->
			<nonbind-vip v-if="isVip"></nonbind-vip>
			<!-- 未开通超级会员提示 -->
			<nonbind-svip v-if="isSVip"></nonbind-svip>
		</div>
	</div>
</template>

<script>
	import NonbindVip from '@/components/NonBind/nonbindVip.vue'
	import NonbindSvip from '@/components/NonBind/nonbindSVip.vue'
	import { getCertificateInfoVoList } from '@/api/qualificationQuery/person'
	// 行为记录
	export default {
		name: 'CertificateInfoVoDetail',
		components: { NonbindVip, NonbindSvip },
		props: {
			id: {
				type: String,
				required: true,
				default: ''
			},
			idCard: {
				type: String,
				required: true,
				default: ''
			}
		},
		data() {
			return {
				// 数据加载状态
				loading: false,
				isVip: false,
				isSVip: false,
				detailInfo: [],
				message: ''
			}
		},
		computed: {},
		watch: {},
		created() {},
		mounted() {
			this.initDetail()
		},
		methods: {
			initDetail() {
				this.loading = true
				const params = {
					idCard: this.idCard,
					certificateCode: this.id
				}
				getCertificateInfoVoList(params)
					.then(response => {
						const { data, code, message } = response

						if (code === 6102) {
							this.isVip = true
						} else if (code === 6104) {
							// 当前是svip 权益已经使用完，提示次数已经用完了，请等待会员权益重置再使用
							this.$message.warning(message)
						} else if (code === 6105) {
							// 当前是vip 权益已经使用完，提示次数已经用完了，请用户升级为svip
							this.isSVip = true
						} else {
							if (data) {
								this.detailInfo = data
							}
						}
						this.loading = false
					})
					.catch(err => {
						this.loading = false
					})
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import '~@/styles/timeline.scss';
</style>
